// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2989":"1dcb6ff9","3878":"37c27605","8153":"bd94a229","8430":"261e98bc"}[chunkId] + ".chunk.css";
};